import { CommonDestinationTimezone } from "./utils";
import moment, { type Moment, MomentBuiltinFormat } from "moment-timezone";

export function formatDateWithoutTimezone(date: Date): string {
  if (!('getFullYear' in date)) {
    throw new Error(`Unexpected date format in fromatDateWithoutTimezone. ${typeof date} ${date}`);
  }

    // Extract the components of the date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(date.getDate()).padStart(2, '0');

    // Format the date as YYYY/MM/DD
    const formattedDate = `${year}/${month}/${day}`;

    return formattedDate;
}

export function formatDateWithoutTimezoneToDate(date: Date): Date {
    // Extract the components of the date
    return moment.tz(formatDateWithoutTimezone(date), "YYYY/MM/DD", CommonDestinationTimezone).toDate()
}

export function formatDateWithoutTimezoneToFormat(date: Date, format: string): string {
    // Take the local calendar day (Y/M/D) and re-emit it in the requested format.
    return moment.tz(formatDateWithoutTimezone(date), "YYYY/MM/DD", CommonDestinationTimezone).format(format)
}

export function convertFormatStringToLocalTimezone(date: string, format: string): Date {
    const localTimezone = moment.tz.guess() ?? CommonDestinationTimezone;
    // Extract the components of the date
    return moment.tz(date, format, localTimezone).toDate()
}

export function convertFormatMomentToLocalTimezone(date: Moment): Date {
  const localTimezone = moment.tz.guess() ?? CommonDestinationTimezone;
    // Extract the components of the date
  return moment.tz(date.format("YYYY-MM-DD"), "YYYY-MM-DD", localTimezone).toDate()
}

export function safeParseMomentWithFormats(date: string, inputFormats: (string | MomentBuiltinFormat)[], timezone?: string): Moment | undefined {
  return inputFormats.reduce((acc: Moment | undefined, inputFormat: string | MomentBuiltinFormat) => {
    if (!!acc) return acc;
    const parsed = safeParseDateMomentWith(date, inputFormat, timezone);
    return parsed;
  }, undefined);
}

export function safeParseDateMomentWith(date: string | Date, inputFormat: string | MomentBuiltinFormat, timezone?: string) {
  if (!date) return undefined;

  if (typeof date === "string") {
    const localTimezone = moment.tz.guess();
    const item = moment.tz(date, inputFormat, true, timezone ?? localTimezone);
    if (!item.isValid()) return undefined;

    return item;
  }

  const item = moment.tz(date, CommonDestinationTimezone);
  if (!item.isValid()) return undefined;

  return item;
}
